// dependencies
import React from "react";
import { View } from "react-native";
import { useIntl } from "react-intl";

// components
import Stack from "@cloudspire/legacy-resources/src/components/Stack";
import Text from "@cloudspire/legacy-resources/src/components/Text";
import Image from "@cloudspire/legacy-resources/src/components/Image";
import Button from "@cloudspire/legacy-resources/src/components/Button";
import Link from "@cloudspire/legacy-resources/src/components/Link";

// contexts
import { useConfiguration } from "@cloudspire/legacy-resources/src/contexts/configuration";
import { useRouters } from "@cloudspire/legacy-resources/src/contexts/routers";

// libraries
import {
  emToPx,
  formatPhone,
} from "@cloudspire/legacy-resources/src/libraries";
import { generateUri } from "@cloudspire/legacy-shared/src/libraries";

type PropsType = {};

const RoomListNoResultsContainer: React.FunctionComponent<PropsType> = () => {
  const intl = useIntl();

  const configuration = useConfiguration();

  const { frontRouter } = useRouters();

  return (
    <View style={{ width: "100%" }}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <View style={{ width: "100%", maxWidth: emToPx(50) }}>
          <Image
            source={{
              uri: "/images/splashes/room-list-no-results.svg",
            }}
          />
        </View>
      </View>
      <Stack marginTop={1} />
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <View style={{ width: "100%", maxWidth: emToPx(50) }}>
          <Text>
            {intl.formatMessage({
              defaultMessage:
                "Les hébergements correspondants à votre recherche ne sont pas immédiatement disponibles.",
            })}
          </Text>

          <Text>
            {intl.formatMessage({
              defaultMessage:
                "Nous vous invitons à retirer quelques filtres, et/ou à étendre votre zone de recherche.",
            })}
          </Text>

          <Text>
            {intl.formatMessage(
              {
                defaultMessage:
                  "Nous vous invitons à nous{hasPhone, select, true { appeler au {phone}} other { contacter,}} nous pouvons immédiatement vous accompagner dans votre projet de séjour.",
              },
              {
                hasPhone: Boolean(
                  configuration.channel.informations.booking.phone
                ),
                phone: formatPhone(
                  configuration.channel.informations.booking.phone
                ),
              }
            )}
          </Text>

          <Text>
            {intl.formatMessage(
              {
                defaultMessage:
                  "Vous pouvez également nous faire part de votre demande à l’aide de notre <to>formulaire de contact</to>.",
              },
              {
                to: (...chunks) => (
                  <Link
                    key="to"
                    style={{ textDecorationLine: "underline" }}
                    to={generateUri({
                      router: frontRouter,
                      name: "App.Action.Contact",
                      parameters: {
                        lang: intl.locale,
                      },
                    })}
                  >
                    {chunks}
                  </Link>
                ),
              }
            )}
          </Text>
        </View>
      </View>
      <Stack marginTop={1} />
      <View
        style={{
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <Button
          color="reversed-brand"
          to={generateUri({
            router: frontRouter,
            name: "App.Action.RoomList",
            parameters: {
              lang: intl.locale,
            },
          })}
          external={true}
          accessibilityLabel={intl.formatMessage({
            defaultMessage: "Nouvelle recherche",
          })}
        >
          {intl.formatMessage({
            defaultMessage: "Nouvelle recherche",
          })}
        </Button>
      </View>
    </View>
  );
};

export default RoomListNoResultsContainer;
